export default __webpack_public_path__ + "static/media/icon-insights-manage-prices.ed1e5186.svg";